import EditorJS from '@editorjs/editorjs'
import Header from '@editorjs/header'
import Quote from '@editorjs/quote'
import NestedList from '@editorjs/nested-list'
import Checklist from '@editorjs/checklist'
import Link from '@editorjs/link'
import Embed from '@editorjs/embed'
import Table from '@editorjs/table'
import Attaches from '@editorjs/attaches'
import DragDrop from 'editorjs-drag-drop'
import Columns from '@calumk/editorjs-columns'
import Delimiter from '@editorjs/delimiter'
import ImageTool from '@editorjs/image'
import { removeEmptyParagraph, checkIfBase64ImagesExist } from '@/scripts/plugins/editorjs/imports/functions'

document.addEventListener('DOMContentLoaded', function () {
    const editorElements = document.querySelectorAll('.editorjs')
    editorElements.forEach((element) => {
        const elementId = element.id
        if (elementId) loadEditorJSContent(elementId)
    })
})

/**
 * Function: loadEditorJSContent
 * @description Initializes EditorJS with dynamic tools and loads content.
 */
const loadEditorJSContent = (editor_id) => {
    const editorElement = document.getElementById(editor_id)
    let editor_content = editorElement?.dataset.editorjsContent

    if (editor_content && typeof editor_content === 'string') {
        try {
            editor_content = JSON.parse(editor_content)
        } catch (e) {
            console.error('Failed to parse content:', e)
        }
    }

    // Filter out invalid/null blocks
    if (editor_content && editor_content?.blocks)
        editor_content.blocks = editor_content.blocks.filter(block => block && block.type)

    // Check for readonly status
    const read_only = !editorElement.classList.contains('editorjs-editable')

    // Detect if base64 images exist
    const is_base_64 = checkIfBase64ImagesExist(editor_content)

    // Initialize tools conditionally
    const tools = {
        embed: Embed,
        delimiter: Delimiter,
        header: { class: Header, inlineToolbar: ['link'] },
        quote: {
            class: Quote,
            inlineToolbar: true,
            config: {
                quotePlaceholder: 'Enter a quote',
                captionPlaceholder: "Quote's author",
            },
        },
        image: {
            class: ImageTool
        },
        list: { class: NestedList, inlineToolbar: true },
        checklist: { class: Checklist, inlineToolbar: true },
        link_preview: {
            class: Link
        },
        table: {
            class: Table,
            inlineToolbar: true,
            config: { rows: 2, cols: 3 },
        },
        attaches: { class: Attaches },
        columns: {
            class: Columns,
            inlineToolbar: true,
            config: {
                EditorJsLibrary: EditorJS,
                tools: {
                    embed: Embed,
                    delimiter: Delimiter,
                    header: Header,
                    quote: Quote,
                    image: { class: ImageTool },
                    nestedList: NestedList,
                    checklist: Checklist,
                    link_preview: {
                        class: Link
                    },
                    table: Table,
                    attaches: { class: Attaches },
                },
            },
        },
    }

    const editor = new EditorJS({
        holder: editor_id,
        readOnly: read_only,
        tools: tools,
        data: editor_content?.blocks?.length ? editor_content : null,
        onReady: () => {
            new DragDrop(editor)
            if (read_only) removeEmptyParagraph()

            // Post-process images after rendering
            editor.isReady.then(() => {
                const images = document.querySelectorAll(`#${editor_id} .ce-block .ce-block__content img`)
                images.forEach(img => {
                    if (!img.closest('a[data-fslightbox]')) {
                        const anchor = document.createElement('a')
                        anchor.href = img.src
                        anchor.dataset.fslightbox = 'gallery'
                        img.parentNode.insertBefore(anchor, img)
                        anchor.appendChild(img)
                    }
                })

                refreshFsLightbox()
            })
        },
        onChange: () => {
            const saveButton = document.querySelector('[data-editor-save-button]')
            if (saveButton) saveButton.removeAttribute('disabled')
        },
    })
}